import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "darkScrim", "handleClose", "open", "showCloseIcon", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Dialog, Grid, Icon, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
var DARK_SCRIM = 'rgba(67, 74, 79, .8)';
var LIGHT_SCRIM = 'rgba(67, 74, 79, .4)';

var TAGDialog = function TAGDialog(_ref) {
  var children = _ref.children,
      _ref$darkScrim = _ref.darkScrim,
      darkScrim = _ref$darkScrim === void 0 ? false : _ref$darkScrim,
      handleClose = _ref.handleClose,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$showCloseIcon = _ref.showCloseIcon,
      showCloseIcon = _ref$showCloseIcon === void 0 ? false : _ref$showCloseIcon,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(React.Fragment, null, React.createElement(Dialog, _objectSpread(_objectSpread({}, props), {}, {
    open: open,
    scroll: "paper",
    onClose: handleClose,
    sx: [{
      '&.MuiModal-root': {
        backgroundColor: darkScrim ? DARK_SCRIM : LIGHT_SCRIM,
        '.MuiDialog-container': {
          '.MuiPaper-root': {
            borderRadius: '8px',
            position: 'relative',
            '#swipeable > .react-swipeable-view-container > div': {
              '::-webkit-scrollbar': {
                display: 'none'
              }
            }
          }
        }
      }
    }, sx]
  }), showCloseIcon && React.createElement(Grid, {
    container: true,
    sx: {
      width: 'fit-content',
      position: 'absolute',
      top: '12px',
      right: '5px',
      zIndex: '1'
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(IconButton, {
    onClick: handleClose
  }, React.createElement(Icon, null, React.createElement(Close, null))))), children));
};

export default TAGDialog;